<form [formGroup]="model.asForm" (ngSubmit)="enviar()">
    <div>
      <div>
        <div>
          <span class="text-black"> Poderia nos dizer o motivo que deseja cancelar a proposta? </span>
        </div>
        <div class="mt-2">
          <mat-radio-group
            aria-labelledby="example-radio-group-label"
            class="d-grid"
            formControlName="mensagemId">
            <mat-radio-button (change)="radioChange($event)" class="example-radio-button" *ngFor="let motivo of listaMotivos" [value]="motivo?.mensagemId">
              {{motivo?.mensagem}}
            </mat-radio-button>
          </mat-radio-group>
          <div class="invalid-feedback-inputs" *ngIf="!validarFormulario && model.asForm.controls.mensagemId.invalid">
            <span>Campo obrigatório</span>
          </div>

          <div class="form-group">
            <app-input-text-area
              [label]="''"
              [id]="'observacao'"
              [rows]="3"
              [required]="false"
              [maxlength]="LIMITES_CARACTERES.OBSERVACAO"
              [placeholder]="'Por favor, informe mais detalhes da sua decisão'"
              [invalid]="!validarFormulario && model.asForm.controls.observacao.invalid"
              [msgAlerta]="'Campo obrigatório'"
              formControlName="observacao"></app-input-text-area>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="row mt-3">
    <div class="col-6">
        <button class="btn btn-outline-secondary btn-sm w-100" (click)="fechar()"> Voltar </button>
    </div>
    <div class="col-6">
        <button (click)="enviar()" class="btn btn-primary float-end btn-sm w-100"> Ok </button>
    </div>
</div>
